import { NotificationManagement } from "pages";
import adminRouteMap from "routeControl/adminRouteMap";

/**
 * Generates an array of route objects for user management in the admin section.
 * @returns {Array} An array containing the route objects for user management.
 */
export default function route() {
  return [
    {
      path: adminRouteMap.NOTIFICATION_MANAGEMENT.path,  // URL path for user management
      name: "Notification Management",  // Display name for the route
      key: adminRouteMap.NOTIFICATION_MANAGEMENT.path,  // Unique key for the route
      private: true,  // Requires authentication to access
      belongsToSidebar: true,  // Appears in the admin sidebar
      icon: adminRouteMap.NOTIFICATION_MANAGEMENT.icon,  // Icon associated with user management
      element: <NotificationManagement />,  // Component to render for user management route
    },
  ];
}
